export default {
  'to-ss': 'Mintegral Advertiser Self-service Platform',
  domain: {
    tips: {
      title: 'Domain Change Notification',
      content:
        'We have upgraded the access address to provide a more stable service. The current domain will soon be deactivated, so please switch to the new domain as soon as possible and log in again to ensure normal access.',
      submit: 'Redirect now',
    },
  },
  'to-helper': 'Help Center',
  confirmTitle: 'Confirm deletion?',
  confirmTips: 'The creative will be deleted and cannot be recovered.',
  confirmButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
  enterPlaceHolder: 'Please fill in',
  agreement: 'Confidentiality agreement',
  createVersionDialog: {
    version: 'Versions',
    title: 'Create Project',
    createSuccessText: 'Created Successfully',
    confirmText: 'Confirm',
    cancleText: 'Cancel',
    form: {
      name: {
        label: 'Project Name',
        placeholder: 'Please enter the version name',
        required: 'The Version Name cannot be empty.',
        length: 'Maximum length shall not exceed 50 characters',
        format:
          'Only letters, numbers, and underscores can be input, spaces are not supported.',
        duplicateName: 'Duplicate Name',
      },
      description: {
        placeholder: 'Please enter the version description',
        required: 'The version description cannot be empty',
        length: 'Maximum length shall not exceed 500 characters',
      },
    },
  },
  downloadTaskDialog: {
    title: 'Compressing Files',
    loading: 'Compressing',
    failed: 'Compressing Failed',
    running: {
      a: 'Compressing',
      b: 'files',
    },
    download: 'Download',
    packed: 'Complete',
    stopDialog: {
      message: 'Do you want to stop compressing?',
      content:
        'The compression has not been completed and cannot be downloaded. Do you want to stop?',
      keep: 'Continue',
      cancel: 'Cancel',
    },
  },
  playUnitTitle: 'Quick Layout',
  fontForbidden: {
    msg: 'This project contains fonts that have been removed, please select other fonts',
    set: 'Reset',
    cancel: 'Cancel',
    ok: 'ok',
    msgDialog:
      'The following fonts cannot be used. Please select a replacement font.',
  },
  downloadVersionDialog: {
    title: 'Download Work',
    version: {
      new: 'Latest version',
      history: 'Historical version',
    },
    package: {
      status: {
        label: 'Status',
        ready: 'Ready',
        done: 'Downloaded',
      },
      zipType: {
        label: 'Compression method',
        normal: 'Smart compression (balance file quality and size)',
        custom: 'Custom compression',
      },
      downloadNotice: 'Please select the network to download',
      previewTitle: 'Preview',
      back: 'Back',
      label: 'Size Limit',
      image: 'Quality',
      qualityLabel: {
        normal: 'Quality',
        image: 'Image Quality',
        video: 'Video Quality',
        audio: 'Audio Quality',
      },
      counting: 'counting',
      apply: 'Apply and calculate',
      preview: 'Preview',
      desc: 'File Size',
      fileSize: 'File Size',
      limit: 'Unlimited',
    },
    downloadTips:
      'Files downloaded here cannot be applied. It is recommended to use the [Apply] function to apply your playable to your Mintergral SS advertising platform.',
    deploymentTips:
      'After downloading the InMobi playable material, you need to deploy the offline script content to the CDN and manually modify the paths in the HTML file for the material to function properly.',
    eventDetectionTips: 'Please set an end scene or event and try again.',
    mtgDisabledTips: 'Apply to Mintegral with one click, no download required.',
    notProduct: 'Please select product information first.',
    unauthorized: 'Network is not authorized.',
    channelLable: {
      mintegral: 'Mintegral',
      other: 'Other Networks',
      choose: 'Networks',
    },
    table: {
      column: {
        channel: 'Networks',
        platform: 'Platform',
      },
      action: {
        checkall: 'Select All',
      },
      disabledDownload: 'This channel does not support downloading.',
    },
    download: 'Download',
    copylink: 'Get link',
    wxgame: {
      disableTips:
        'This project uses features not supported by WeChat. Please make adjustments and try again.',
      ctaTips:
        'WeChat MiniGame does not support redirection to app stores. Please remove any related CTA buttons or steps.',
      previewTips:
        'WeChat MiniGame playables do not support previewing. You can check the trial effect through the project preview instead.',
    },
  },
  plPreview: {
    history: {
      tips: 'Historical versions only support re-downloading on previously downloaded channels and do not support secondary push.',
    },
    crumb: {
      ps: {
        title: 'Playable Content Editor',
      },
    },
    creativeName: {
      placeHolder: 'Please enter the creative name.',
    },
  },
  pushDialog: {
    title: 'Apply',
    accountOptions: {
      local: 'Current Account',
      other: 'Other Account',
      new: 'New Account',
    },
    cancleLabel: 'Cancel',
    confirmLabel: 'Confirm',
    form: {
      accountType: {
        label: 'Account',
        message: 'Please select an account',
        placeholder: 'Please select an account',
      },
      name: {
        label: 'Account',
        message: 'Username Or Email',
        placeholder: 'Username Or Email',
      },
      password: {
        label: 'Password',
        message: 'Password',
        placeholder: 'Password',
      },
    },
    packageManager: {
      remainLable: 'Download Remaining',
      totalLabel: 'Total',
      remainTips: {
        A: 'Total = 30-day downloads + additional purchased downloads',
        B: 'Your downloads will be reset every 30 days (except for additional purchased downloads).',
      },
      progress: {
        network: 'Networks',
        version: 'Works',
        download: 'Download',
      },
      overTips: 'Your selection has exceeded the limit. Please reselect.',
      mintegral: 'Download of Mintegral will not be counted in your quota.',
    },
    pushSuccess: 'Push Successfully',
    pushSuccessA: 'Push Successfully',
  },
  pushInfoConfirm: {
    title: 'Tip',
    cancel: 'Cancel',
    info: 'go to supplementary information',
    emptyText: 'Please add product information before creating a new playable',
  },
  eventInfoConfirm: {
    title: '{title} Failed',
    info: 'Go Setting',
    setUp: 'View How to Set Up',
    emptyInstallText:
      'This project is missing the "Redirect to app store" event. Please set it up before proceeding with {info}.',
    emptyGameEndText:
      'This project is missing an end scene or event. Please set it up before proceeding with {info}.',
    emptyNullText:
      'This project is missing the "Redirect to app store" event, an end scene or event. Please set it up before proceeding with {info}.',
  },
  pushRecordDialog: {
    title: 'Apply History',
    emptyText:
      'This creative has not been applied to Mintegral Advertiser Self-service Platform.',
    closeLabel: 'Close',
    goToAdPlatform: 'Go to Mintegral Advertiser Self-service Platform',
    table: {
      title: 'Work Name',
      language: 'Language',
      platform: 'Platform',
      advName: 'Account',
      status: 'Status',
      updateTime: 'Push Date',
      action: 'Operations',
      preview: 'Preview',
      download: 'Download',
      info: 'Project Info',
    },
    statusList: {
      pending: 'Processing',
      approved: 'Push Successfully',
      rejected: 'rejected',
      failed: 'Push Failed',
      downloaded: 'Downloaded',
      other: 'other',
    },
  },
  historyList: {
    table: {
      column: {
        count: 'Deduction',
        countAll: 'Deduction',
        templateName: 'Template Name',
        time: 'Last edit time',
        fingerprintCount: 'etc., {num} in total.',
        basicId: 'Creative ID and Name',
        creative_version: 'Creative Version Name',
        basicIdCount: 'and other Creative Version IDs',
      },
    },
  },
  pushdownloadRecordDialog: {
    title: 'Export & Download History',
    emptyText: 'No Results',
    table: {
      count: 'Deduction',
      channel: 'Networks',
      updateTime: 'Creation Time',
      fingerprint: 'Creative Fingerprint',
      export: 'Export Excel',
    },
    search: {
      isDecuction: 'Deduct Download Times',
      decuction: 'Deduct',
      notDecuction: 'Not Deduct',
      channel: 'Select Networks',
      platform: 'Select Platform',
    },
    infoDialog: {
      lang: 'Language',
      account: 'Apply to',
    },
  },
  versionBar: {
    exportButton: 'Export',
    createGuide: 'Create New',
    copyButton: 'Copy Version',
    deleteButton: 'Delete',
    deleteSuccess: 'Delete Successfully',
    switchSuccess: 'Switched Successfully',
    deleteForbidden: 'Current version cannot be deleted',
    saveWarningText: 'Do not perform other actions while saving',
    deleteConfirm: {
      title: 'Tip',
      content: 'Are you sure you want to delete this version？',
      header: 'Selected Project',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    option: {
      copyButton: 'Copy',
      deleteButton: 'Delete',
      downloadButton: 'Download',
      copyToMulti: 'Copy to Variant Feature Changer',
      copyToPs: 'Copy to Content Editor',
      copyToDco: 'Copy to DCO',
    },
    saveConfirm: {
      type: {
        copy: 'Copy',
        choose: 'Switch Version',
        create: 'Create',
        export: 'Export',
      },
      content: 'Save the current version before proceeding?',
      title: 'Tip',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    },
  },
  langSelector: {
    label: 'Default Language',
  },
  errorpage: {
    message: 'Please enter a valid URL and try again',
    homeButton: 'Return',
  },
  listNav: {
    menu: {
      normal: 'General Creation',
      dco: 'Edit DCO Playable',
      multi: 'Variant Creation',
    },
    starButton: 'Favorite',
  },
  previewDialog: {
    preview: 'Preview',
    copyText: 'Please copy the link to the browser to preview',
    copyButton: 'Copy',
    reloadButton: 'Replay',
    replay: 'Replay',
    product: 'Product',
    playable: 'Project',
    versionName: 'Version Name',
    dcoid: 'Group ID',
    dcoIdDesc:
      'There are multiple combinations under one DCO ID, and each combination corresponds to a Group ID',
    dcoConfiguration: 'DCO Configuration',
    createVersion: 'Create Project',
    createMultiVersion: 'Create Variation Project',
    createDCOVersion: 'Create New DCO Version',
    editVersion: 'Edit Version',
    copyVersion: 'Duplicate Project',
    copyMultiVersion: 'Duplicate Variation Project',
    copyNewDCOVersion: 'Copy New DCO Version',
    versionManagement: 'Version Management',
  },
  save: {
    autoSaving: 'Auto-saving...',
    saved: 'Changes saved',
    text: 'Save',
    fail: 'Save Failed',
  },
  validate: {
    numberOnly: 'Query allows numbers only',
  },
  balanceThresholdTips:
    'Your balance is below $ {balance_threshold}. To avoid any disruption in service, please recharge promptly.',
  network: {
    networkException: 'Network exception, please refresh and try again.',
  },
  poinitManagement: {
    desc: 'By adding tracking, the creatives will support advanced analysis functions such as interactive data analysis, scene analysis, and user journey analysis.',
    select: {
      tips: 'When selected, the embedded code will be added to all playable creatives downloaded/pushed through the corresponding channels. (Currently, only the above-mentioned channels are supported. Please contact our sales team for support on other channels.) If not selected, the code will not be added. It is recommended to enable the addition of tracking points as it will enable advanced analysis functions such as interactive data analysis, scene analysis, and user journey analysis for the creatives.',
    },
  },
}
